import { createSlice } from "@reduxjs/toolkit";

export const packet = createSlice({
  name: "packetList",
  initialState: {
    value: false, // default state
  },
  reducers: {
    // reducers action
    setPacketList: (state, { payload }) => {
      state.value = payload;
    },
  },
});

export const { setPacketList } = packet.actions;
export default packet.reducer;
